import {createStore} from '@web/helpers/redux'
import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'
import {uiEventLoggerCreator} from '@web/middlewares/uiLogging'

import {RootState} from '../../interfaces/result'

import auth from './middlewares/auth'
import maintenanceHandlerMiddleware from './middlewares/maintenanceHandlerMiddleware'
import createRootReducer from './reducer'
import PurchaseConfirmationResultSentryEnhancer from './sentryEnhancer'
/** 구매확정 store */
const store = createStore<RootState>({
    rootReducerCreator: createRootReducer,
    middlewares: [auth, maintenanceHandlerMiddleware, browserEventEmitter, uiEventLoggerCreator({})],
    sentryEnhancerOptions: PurchaseConfirmationResultSentryEnhancer,
})

export default store
